module.exports = __webpack_public_path__ + "static/img/girl.416a2ef9.png";